export const config = () => {
    return {
        ...process.env
    }
}
